import { getLocale, parseLocale } from '../locale';
import getCurrentMapsAPIInstance from './getCurrentMapsAPIInstance';
const getPlaceDetails = ({ id, sessionToken }) => {
    const mapsAPIInstance = getCurrentMapsAPIInstance();
    const market = parseLocale(getLocale('upperCase')).country;
    if (!mapsAPIInstance) {
        throw new Error('Maps API is not initialized. Use `initializeMapsAPI` first.');
    }
    const getPlaceRequestParams = {
        fields: ['address_components', 'geometry'],
        placeId: id,
        sessionToken,
    };
    const normalizer = (addressComponents, geometryComponent) => {
        const getAddressDetail = (detail) => {
            const detailObject = addressComponents.find((addressComponent) => addressComponent.types[0] === detail);
            return (detailObject === null || detailObject === void 0 ? void 0 : detailObject.long_name) || '';
        };
        const getGeometry = (detail) => {
            const detailObject = geometryComponent.location;
            if (detail === 'lat') {
                return detailObject.lat();
            }
            if (detail === 'lng') {
                return detailObject.lng();
            }
            return null;
        };
        let buildingNumber = getAddressDetail('street_number');
        let route = getAddressDetail('route');
        const country = getAddressDetail('country');
        let province = getAddressDetail('administrative_area_level_1');
        // Removes accent for Mexico, since BE is returning the provinces without accents
        if (market === 'MX') {
            province = province.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }
        if (market === 'IE') {
            province = province.replace('County', 'Co.');
        }
        let city = getAddressDetail('locality') ||
            getAddressDetail('postal_town') ||
            getAddressDetail('sublocality_level_1');
        const postalCode = getAddressDetail('postal_code');
        let houseName = getAddressDetail('premise') || getAddressDetail('subpremise');
        const district = getAddressDetail('sublocality_level_1');
        // Custom logic for Japan since addresses are quite complex
        if (market === 'JP') {
            city = `${getAddressDetail('administrative_area_level_2')}${getAddressDetail('locality')}${getAddressDetail('sublocality_level_1')}${getAddressDetail('sublocality_level_2')}`;
            route = `${getAddressDetail('sublocality_level_3')}${getAddressDetail('sublocality_level_4')}${getAddressDetail('sublocality_level_4') ? '-' : ''}${houseName}`;
            houseName = '';
            buildingNumber = '';
        }
        const lat = getGeometry('lat');
        const lng = getGeometry('lng');
        return {
            buildingNumber,
            route,
            city,
            postalCode,
            country,
            lat,
            lng,
            province,
            houseName,
            district,
        };
    };
    return new Promise((resolve, reject) => {
        const mapsGetPlaceDetailsService = new mapsAPIInstance.places.PlacesService(document.createElement('div'));
        const { OK, ZERO_RESULTS } = mapsAPIInstance.places.PlacesServiceStatus;
        const handleGetPlaceDetailsResponse = (placeDetails, placesServiceStatus) => {
            if (placesServiceStatus === ZERO_RESULTS) {
                resolve([]);
            }
            if (placesServiceStatus === OK) {
                const { address_components: addressComponents, geometry: geometryComponent } = placeDetails;
                const normalizedDetails = normalizer(addressComponents, geometryComponent);
                resolve(normalizedDetails);
            }
            reject(placesServiceStatus);
        };
        mapsGetPlaceDetailsService.getDetails(getPlaceRequestParams, handleGetPlaceDetailsResponse);
    });
};
export default getPlaceDetails;
//# sourceMappingURL=getPlaceDetails.js.map